<template>
  <section class="relative w-full">
    <div
      v-if="envDisplay.show"
      :class="envDisplay.bannerClass"
      class="absolute top-0 left-0 w-full text-center py-0.5 text-[10px] leading-none font-bold uppercase tracking-widest z-50"
    >
      {{ envDisplay.bannerText }}
    </div>

    <div class="flex flex-col justify-center mx-auto h-screen items-center">
      <div class="relative w-full p-10 rounded-lg shadow-[0_0_3px_0_rgba(0,0,0,0.1)] md:mt-0 sm:max-w-md bg-white">
        <div class="mb-8 flex justify-center w-full">
          <div class="relative inline-flex items-start">
            <img
              :src="Logo"
              class="block max-w-60 mx-auto"
            >

            <span
              v-if="envDisplay.show"
              :class="envDisplay.badgeClass"
              class="absolute -right-2 -top-6 px-2 py-0.5 text-[10px] font-bold rounded-sm uppercase tracking-wider"
            >
              {{ envDisplay.badgeText }}
            </span>
          </div>
        </div>

        <slot />
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

import Logo from '@/assets/images/logos/living-plans-logo.svg';
import config from '@/config';

const envDisplay = computed(() => {
  if (config.env === 'staging') {
    return {
      show: true,
      bannerClass: 'bg-[#d946ef] text-white',
      badgeClass: 'bg-[#d946ef] text-white',
      badgeText: 'Staging',
      bannerText: '⚠️ Staging Environment — Test Data Only ⚠️',
    };
  }

  if (config.env === 'development') {
    return {
      show: true,
      bannerClass: 'bg-success text-white',
      badgeClass: 'bg-success text-white',
      badgeText: 'Local Dev',
      bannerText: '🚧 Local Development Environment 🚧',
    };
  }

  return { show: false };
});
</script>
